export default {
  created() {
    if (typeof document === 'undefined') {
      return;
    }

    forEachListener(this, (key, listener) => {
      on(document, key, listener)
    });
  },

  beforeDestroy() {
    if (typeof document === 'undefined') {
      return;
    }

    forEachListener(this, (key, listener) => {
      off(document, key, listener)
    });
  }
}

function forEachListener(vm, f) {
  const events = vm.$options.events;

  Object.keys(events).forEach(key => {
    f(key, (event) => events[key].call(vm, event));
  });
}

function on(el, name, fn) {
  el.addEventListener(name, fn, {passive: false});
}

function off(el, name, fn) {
  el.removeEventListener(name, fn, {passive: false});
}
